import {EntitlementContext} from '@github-ui/copilot-entitlement/EntitlementContext'
import {use, useEffect, useRef} from 'react'

export function useChatEntitlementOnTurnSettlement(turnActive: boolean) {
  const entitlement = use(EntitlementContext)
  const wasTurnActiveRef = useRef(false)
  const reloadQuota = entitlement?.reloadQuota

  useEffect(() => {
    if (wasTurnActiveRef.current && !turnActive) reloadQuota?.('ahp_turn_settled', true)
    wasTurnActiveRef.current = turnActive
  }, [turnActive, reloadQuota])

  return entitlement
}
